import React from "react";

const RightArrowIcon = (props: any) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.8564 13.7216L10.6714 19.9066C10.4652 20.1128 10.259 20.2159 9.94978 20.2159C9.64053 20.2159 9.43436 20.1128 9.2282 19.9066C8.81586 19.4943 8.81586 18.8758 9.2282 18.4635L14.6916 13L9.2282 7.5366C8.81586 7.12427 8.81586 6.50577 9.2282 6.09343C9.64053 5.6811 10.259 5.6811 10.6714 6.09343L16.8564 12.2785C17.2687 12.6908 17.2687 13.3093 16.8564 13.7216Z"
        fill="currentColor"
      />
      <path
        d="M16.8564 13.7216L10.6714 19.9066C10.4652 20.1128 10.259 20.2159 9.94978 20.2159C9.64053 20.2159 9.43436 20.1128 9.2282 19.9066C8.81586 19.4943 8.81586 18.8758 9.2282 18.4635L14.6916 13L9.2282 7.5366C8.81586 7.12427 8.81586 6.50577 9.2282 6.09343C9.64053 5.6811 10.259 5.6811 10.6714 6.09343L16.8564 12.2785C17.2687 12.6908 17.2687 13.3093 16.8564 13.7216Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default RightArrowIcon;
